import React, { Component, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DataTable from "react-data-table-component";
import Sidebar from "../common/sidebar";
import CommonAlert from "../common/Commonalert";
import ShowAlert from "../common/Showalert";
import { canAction } from "../common/permissionhelper";
const MODULE = "manage_emailcampaign";
import ConfirmationPopup from "../common/confirmationPopup";
import { useTranslation } from "react-i18next";
import AlertPopup from "../common/alertPopup";
import { RESTRICTED_EMAIL_TYPES } from "../common/constants";
const EmailConfigs = () => {
  // Permission checks
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const canLogs = canAction(MODULE, "logs");
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const { name } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [templist, setTempList] = useState([]);
  const [searchTextVal, setSearchTextVal] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleStatusAlert, setVisibleStatusAlert] = useState(false);
  const [emailTemplateValue, setEmailTemplateValue] = useState({});
  const [selectedEmailType, setSelectedEmailType] = useState("");
  const emailTypes = [
    { name: t("customer_intro_email_txt"), value: "customer_intro" },
    { name: t("logged_in_ordered_email_txt"), value: "logged_in_not_order" },
    {
      name: t("logged_in_ordered_email_cutoff_txt"),
      value: "logged_in_not_order_cutoff",
    },
    { name: t("abandoned_cart_email_txt"), value: "abandoned_cart" },
  ];
  const [availableEmailTypeOptions, setAvailableEmailTypeOptions] =
    useState(emailTypes);
  const [showAddButton, setShowAddButton] = useState(false);
  const [showTestEmailPopup, setShowTestEmailPopup] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const [statusUpdateSuccess, setStatusUpdateSuccess] = useState(false);
  const [statusSuccessMessage, setStatusSuccessMessage] = useState("");

  const [emailData, setEmailData] = useState({
    toEmail: "",
    emailType: "",
    templateName: "",
    emailSubject: "",
    emailContent: "",
    accountName: "Test Email Account",
    accountCode: "TEST12345",
    header: true,
    footer: true,
  });
  const dummyProducts = [
    {
      productDescription: "test product1",
      productNumber: "TP1",
      packageSize: "5",
      qty: 2,
      itemPrice: 100,
      itemTotal: 200,
    },
    {
      productDescription: "test product2",
      productNumber: "TP2",
      packageSize: "2",
      qty: 2,
      itemPrice: 200,
      itemTotal: 400,
    },
    {
      productDescription: "test product3",
      productNumber: "TP3",
      packageSize: "5",
      qty: 3,
      itemPrice: 250,
      itemTotal: 750,
    },
  ];
  const [errors, setErrors] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertErrorPopup, setAlertErrorPopup] = useState(false);
  const [alertErrorMessage, setAlertErrorMessage] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";

  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_emailcampaign")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    fetchData();
  }, []);

  // useEffect(()=>{
  //         // if(data.length===0) return;
  //         const usedTypes = new Set(data.map(t => t.emailType));
  //         setAvailableEmailTypeOptions( emailTypes.filter(
  //         opt => !usedTypes.has(opt.value)
  //         ));
  //         setShowAddButton(availableEmailTypeOptions.length > 0);
  // },[data])
  const fetchData = async () => {
    setIsLoading(true);
    try {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }

      let URL = BaseUrl + `admin/emailConfigs`;
      const response = await http.get(URL);
      if (response.data.success === true) {
        let responseData = response.data.data.filter(
          (item) => !RESTRICTED_EMAIL_TYPES.includes(item.emailType),
        );
        if (responseData.length > 0) {
          const usedTypes = new Set(responseData.map((t) => t.emailType));
          const availableOptions = emailTypes.filter(
            (opt) => !usedTypes.has(opt.value)
          );
          setAvailableEmailTypeOptions(availableOptions);
          availableOptions.length > 0
            ? setShowAddButton(true)
            : setShowAddButton(false);
        } else {
          setShowAddButton(true);
        }
        setData(responseData);
        setTempList(responseData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handlefilterChange = (value) => {
    setSelectedEmailType(value);
  };
  useEffect(() => {
    filterData();
  }, [selectedEmailType, searchTextVal]);

  const toggleEmailTemplateStatus = (value) => {
    console.log("test de");
    setVisibleStatusAlert(true);
    setEmailTemplateValue(value);
  };

  const updateEmailTemplateStatus = async () => {
    setVisibleStatusAlert(false); // close popup
    setIsStatusUpdating(true); // show loading
    const isCurrentlyActive = emailTemplateValue.status;
    const action = isCurrentlyActive === "active" ? "deactive" : "active";
    const payload = {
      id: emailTemplateValue._id,
      status: action,
    };
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }

    let URL = BaseUrl + `admin/editEmailConfig`;
    try {
      const res = await http.put(URL, payload);
      if (res.data.success) {
        // UPDATE THE DATA IN UI (NO RELOAD)
        setData((prev) =>
          prev.map((item) =>
            item._id === emailTemplateValue._id
              ? { ...item, status: action }
              : item,
          ),
        );
        setTempList((prev) =>
          prev.map((item) =>
            item._id === emailTemplateValue._id
              ? { ...item, status: action }
              : item,
          ),
        );
        // SHOW SUCCESS POPUP
        setStatusSuccessMessage(
          t("email_config_status_updated_msg", {
            status:
              action === "active" ? t("activated_txt") : t("deactivated_txt"),
            templateName: emailTemplateValue.templateName,
          }),
        );
        setStatusUpdateSuccess(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsStatusUpdating(false); // stop loader
    }
  };

  const statusAlertPopupclose = () => {
    setVisibleStatusAlert(false);
    setEmailTemplateValue({});
  };

  const handleShowEditEmailConfig = (value) => {
    const templateData = {
      id: value._id,
      templateName: value.templateName,
      emailType: value.emailType,
      emailSubject: value.emailSubject,
      emailContent: value.emailContent,
      header: value.header,
      footer: value.footer,
      reminderInterval: value.reminderInterval,
      reminderEmailSubject: value.reminderEmailSubject,
      reminderEmailContent: value.reminderEmailContent,
      reminderCountLimit: value.reminderCountLimit,
      reminderHeader: value.reminderHeader,
      reminderFooter: value.reminderFooter,
    };
    navigate("/email-configuration/edit", {
      state: { templateData }, // pass your data here
    });
  };

  const showDeletePopup = (value) => {
    setVisibleAlert(true);
    setEmailTemplateValue(value);
  };

  const showTestMailPopup = (value) => {
    setShowTestEmailPopup(true);
    setEmailTemplateValue(value);
  };

  const handleTestEmailValue = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setEmailData((prev) => ({ ...prev, [name]: value }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const findEmailTypeName = (emailType) => {
    const currentEmailType = emailTypes.find(
      (item) => item.value === emailType,
    );
    return currentEmailType ? currentEmailType.name : emailType;
  };

  const showConfirmationDialog = () => {
    setEmailData((prev) => ({
      ...prev,
      emailType: emailTemplateValue.emailType,
      templateName: emailTemplateValue.templateName,
      emailSubject: `Test Email for ${findEmailTypeName(
        emailTemplateValue.emailType,
      )}`,
      emailContent: emailTemplateValue.emailContent,
    }));
    const isValid = validateEmail(emailData.toEmail);
    if (isValid) {
      setShowDialog(true);
      setShowTestEmailPopup(false);
    }
  };

  const validateEmail = (email) => {
    //var emailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/;
    var emailRegex =
      /^[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/g;
    if (!emailRegex.test(email)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        toEmail: t("valid_email_errmsg_txt"),
      }));
      return false;
    } else {
      return true;
    }
  };
  const sendTestEmail = (e) => {
    e.preventDefault();
    setAlertPopup(false);
    setAlertErrorPopup(false);
    const isValid = validateEmail(emailData.toEmail);
    if (isValid) {
      setIsSendingEmail(true);
      setShowDialog(false);
      const payload = emailData;
      if (emailData.emailType === "abandoned_cart") {
        payload.items = dummyProducts;
      }
      let URL = BaseUrl + `admin/sendTestEmail`;
      http
        .put(URL, payload)
        .then((response) => {
          if (response.data.success) {
            setAlertMessage(
              t("testmail_success_msg_txt", {
                emailType: findEmailTypeName(emailData.emailType),
              }),
            );
          } else {
            setAlertMessage(t("something_went_wrongs_txt"));
          }
          setAlertPopup(true);
          clearTestEmailData();
        })
        .catch((error) => {
          setAlertErrorMessage(t("sending_mail_error_txt"));
          setAlertErrorPopup(true);
          clearTestEmailData();
        })
        .finally(() => {
          setIsSendingEmail(false);
          clearTestEmailData();
        });

      setShowTestEmailPopup(false);
    }
  };

  const deleteEmailTemplate = () => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }

    let URL = BaseUrl + `admin/deleteEmailConfig/${emailTemplateValue._id}`;
    http
      .delete(URL)
      .then(async (response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setEmailTemplateValue({});
  };

  const columns = [
    {
      name: t("template_name_txt"),
      selector: (row) => row?.templateName,
      sortable: true,
    },
    {
      name: t("email_type_txt"),
      selector: (row) =>
        emailTypes.find((opt) => opt.value === row.emailType)?.name ||
        row.emailType,
      sortable: true,
    },
    {
      name: t("reminder_limit_txt"),
      selector: (row) => row?.reminderCountLimit || "-",
      sortable: true,
    },
    // {
    //     name: "Status",
    //     selector: row => (
    //     <div style={{ textTransform: "capitalize" }}>
    //     {row?.status}
    //     </div>
    //     ),
    // },

    {
      name: t("actions_txt"),
      selector: (row) => {
        const canEdit = canAction("manage_emailcampaign", "edit");
        return (
          <div style={{ display: "flex" }}>
            <a
              className="button title-tooltip title-up"
              data-title={canEdit ? t("edit_txt") : t("view_txt")}
              style={{ color: "white" }}
              onClick={() => handleShowEditEmailConfig(row)}
            >
              <i
                className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                aria-hidden="true"
              ></i>
            </a>
            {canAction("manage_emailcampaign", "activate") && (
              <a
                className={`button title-tooltip title-up ${
                  row.accountStatus === "active" ? "activate" : "deactivate"
                }`}
                data-title={t("act_deact_txt")}
                onClick={() => toggleEmailTemplateStatus(row)}
              >
                <i
                  className={`fa ${
                    row.status === "active" ? "fa-unlock" : "fa-lock"
                  }`}
                ></i>
              </a>
            )}
            {canAction("manage_emailcampaign", "delete") && (
              <a
                className="button title-tooltip title-up"
                data-title={t("delete_txt")}
                style={{ color: "white" }}
                onClick={() => showDeletePopup(row)}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
            )}
            {canAction("manage_emailcampaign", "runemail") && (
              <a
                className="button title-tooltip title-up"
                data-title={t("test_mail_txt")}
                style={{ color: "white" }}
                onClick={() => showTestMailPopup(row)}
              >
                <i className="fa fa-envelope-o"></i>
              </a>
            )}
          </div>
        );
      },
      sortable: false,
    },
  ];
  const handleReset = () => {
    setSearchTextVal("");
  };

  const handleChange = async (value) => {
    setSearchTextVal(value);
  };

  const handleAddEmailConfig = () => {
    navigate("/email-configuration/add");
  };

  const handleEmailLogs = () => {
    navigate("/email-logs");
  };

  const normalize = (str = "") => str.toLowerCase().replace(/[\s\-_]+/g, "");

  const filterData = async () => {
    let currentFilterData = templist;
    //Email Type Filter
    if (selectedEmailType != "") {
      currentFilterData = currentFilterData.filter((item) =>
        item.emailType
          ?.toString()
          .toLowerCase()
          .includes(selectedEmailType.toLowerCase()),
      );
    }

    //Search Filter
    const input = (searchTextVal ?? "").toString().trim();
    if (input.length > 0) {
      const searchKey = normalize(input);

      currentFilterData = currentFilterData.filter((item) => {
        // always allow templateName matches
        const nameMatch = normalize(item.templateName).includes(searchKey);

        // match against the stored emailType value (e.g. "logged_in_not_order")
        const typeValueMatch = normalize(item.emailType || "").includes(
          searchKey,
        );

        // match against the friendly display name in emailTypes (e.g. "Logged In - Not Ordered")
        const friendlyMatch = emailTypes.some(
          (t) =>
            t.value === item.emailType && normalize(t.name).includes(searchKey),
        );

        return nameMatch || typeValueMatch || friendlyMatch;
      });
    }
    setData(currentFilterData);
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px", // override the cell padding for head cells
      },
    },
    cells: {
      style: {
        padding: "8px", // override the cell padding for data cells
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  const hideConfirmationDialog = () => {
    setShowDialog(false);
    setAlertPopup(false);
    setAlertErrorPopup(false);
    clearTestEmailData();
  };
  const hideTestEmailPopup = () => {
    setShowTestEmailPopup(false);
    setAlertPopup(false);
    setAlertErrorPopup(false);
    clearTestEmailData();
  };

  const clearTestEmailData = () => {
    setEmailData((prev) => ({
      ...prev,
      toEmail: "",
      emailContent: "",
      emailSubject: "",
      templateName: "",
      emailType: "",
    }));
    setErrors({});
    setShowTestEmailPopup(false);
    setShowDialog(false);
  };

  return (
    <section className="dashboard-block">
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          {alertPopup && <AlertPopup title={t("alert_txt")} message={alertMessage} handleOk={() => setAlertPopup(false)}/>}
          {alertErrorPopup && (
            <AlertPopup title={t("alert_txt")} message={alertErrorMessage} handleOk={() => setAlertErrorPopup(false)}/>
          )}
          {statusUpdateSuccess && <AlertPopup title={t("alert_txt")} message={statusSuccessMessage} handleOk={() => setStatusUpdateSuccess(false)}/>}
          <div className="container">
            <div className="flex-title">
              <h1 className="checkout-title">
                {t("email_configuration_title_txt")}
              </h1>
            </div>
            <div className="right-table-outer-wrap">
              <div className="table-filter search-orders">
                <div className="table-search-reset">
                  <div className="table-search">
                    <input
                      type="text"
                      value={searchTextVal}
                      onChange={(e) => handleChange(e.target.value)}
                      className="form-control"
                      placeholder={t("email_config_search_placeholder_txt")}
                    />
                  </div>
                  <button
                    className="submitbtn button search-ord-btn"
                    onClick={(e) => filterData(searchTextVal)}
                  >
                    <i className="fa fa-search"></i>
                  </button>

                  <button
                    className="resetbtn"
                    type="reset"
                    onClick={() => handleReset()}
                  >
                    {t("reset_txt")}
                  </button>
                </div>
                {canAction("manage_emailcampaign", "add") &&
                  showAddButton === true && (
                    <div>
                      <button onClick={() => handleAddEmailConfig()}>
                        {t("add_txt")}{" "}
                      </button>
                    </div>
                  )}
                {/* <div className="orders-dropdown prod-select-drop">
                                    <select
                                    className="handle-srch"
                                    value={selectedEmailType}  
                                    onChange={(e) => handlefilterChange(e.target.value)}
                                    >
                                        <option value="" disabled>
                                            Email Type
                                        </option>
                                        <option value=" ">All</option>
                                        <option value="Logged-In Not Order">Logged-In Not Order</option>
                                        <option value="Abandoned Cart">Abandoned Cart</option>
                                        <option value="Customer Intro">Customer Intro</option>
                                    </select>
                      </div> */}
              </div>
              <div className="table_overflow email_config_table">
                <DataTable
                  columns={columns}
                  noDataComponent={
                    <div className="no-records-found">
                      {t("no_records_found_txt", {
                        recordType: "Email Configurations",
                      })}
                    </div>
                  }
                  data={data}
                  customStyles={customStyles}
                  pagination
                  paginationPerPage={25}
                  progressPending={isLoading}
                  paginationRowsPerPageOptions={[25, 50, 75, 100]}
                  paginationComponentOptions={paginationComponentOptions}
                />
              </div>
            </div>
            {isSendingEmail && (
              <div className="loading-full-bg">
                <div className="loading-buffer"></div>
              </div>
            )}
            {isStatusUpdating && (
              <div className="loading-full-bg">
                <div className="loading-buffer"></div>
              </div>
            )}
            {visibleAlert && (
              <ConfirmationPopup
                title={t("alert_txt")}
                confirmationMessage={t("delete_confirm_txt")}
                handleYes={() => deleteEmailTemplate()}
                handleNo={() => alertPopupclose()}
                yesButtonText={t("ok_txt")}
                noButtonText={t("cancel_txt")}
              />
            )}
            {visibleStatusAlert && (
              <ConfirmationPopup
                title={t("alert_txt")}
                confirmationMessage={t("email_config_statuschange_coform_txt", {
                  statusChange:
                    emailTemplateValue.status === "active"
                      ? t("deactive_txt")
                      : t("activate_txt"),
                  templateName: emailTemplateValue.templateName,
                })}
                handleYes={() => updateEmailTemplateStatus()}
                handleNo={() => statusAlertPopupclose()}
                yesButtonText={t("ok_txt")}
                noButtonText={t("cancel_txt")}
              />
            )}
            {showTestEmailPopup && (
              <div className="custom-alert-pop testemail-popup">
                <div className="custom-alert-container">
                  <div className="custom-alert-wrap">
                    <div className="custom-alert-header">
                      <h4>
                        {t("send_testemail_title", {
                          emailType: findEmailTypeName(
                            emailTemplateValue.emailType,
                          ),
                        })}
                      </h4>
                    </div>
                    <div className="custom-alert-body text-left">
                      {/* Radio Buttons */}
                      <div className="input-field">
                        <label htmlFor="emailOption">
                          {t("recipient_email_txt")}
                        </label>
                        <input
                          type="text"
                          name="toEmail"
                          value={emailData.toEmail}
                          onChange={handleTestEmailValue}
                        />
                        {errors.toEmail && (
                          <div className="error-msg">{errors.toEmail}</div>
                        )}
                      </div>

                      <div className="alert-buttons">
                        <button
                          onClick={showConfirmationDialog}
                          className="popup-alert-btn button"
                        >
                          {t("submit_txt")}
                        </button>
                        <button
                          onClick={() => hideTestEmailPopup()}
                          className="popup-alert-btn button"
                        >
                          {t("cancel_txt")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showDialog && (
              <ConfirmationPopup
                title={t("alert_txt")}
                confirmationMessage={t("send_test_email_conform_msg", {
                  toEmail: emailData.toEmail,
                })}
                handleYes={sendTestEmail}
                handleNo={hideConfirmationDialog}
              />
            )}
          </div>
        </section>

        <Footer />
      </div>
    </section>
  );
};
export default EmailConfigs;
